import Swiper, { EffectFade, Pagination, Autoplay } from "swiper";

window.addEventListener(
  "load",
  () => {
    const swiperIntro = new Swiper(".testimonials-carousel-2__carousel", {
      modules: [EffectFade, Pagination, Autoplay],
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  },
  false
);
